import * as React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';

const LoadingHorseRowComponent = ({
  classes,
  numColumns = 6,
}) => (
  <TableRow className={classes.row}>
    <TableCell>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="circular" width={45} height={45} sx={{ marginRight: 1 }} />
        <Skeleton
          variant="text"
          width={50}
          height={50}
          sx={{
            color: 'action.active',
            mr: 1,
            my: 0.5,
          }}
        />
        <Skeleton
          variant="text"
          width={50}
          height={30}
          sx={{
            color: 'action.active',
            mr: 1,
            my: 0.5,
          }}
        />
      </Box>
    </TableCell>
    {
      Array.from(Array(numColumns).keys()).map((i) => (
        <TableCell key={`loading-billable-${i}`}><Skeleton variant="text" width={60} height={30} key={`loading-row-${i}`} /></TableCell>
      ))
    }
  </TableRow>
);

LoadingHorseRowComponent.propTypes = {
  classes: PropTypes.object,
  numColumns: PropTypes.number,
};

LoadingHorseRowComponent.defaultProps = {
  classes: {},
  numColumns: 6,
};

export default LoadingHorseRowComponent;
